import * as THREE from 'three';

/**
 * Represents the player's visual model
 */
export class PlayerModel {
  // Player object
  private object: THREE.Object3D;
  
  // Player mesh
  private mesh: THREE.Mesh;
  
  // Eye height above player position
  private eyeHeight: number = 1.7;
  
  /**
   * Creates a new PlayerModel
   */
  constructor() {
    // Create player object
    this.object = new THREE.Object3D();
    
    // Create player mesh (invisible in first-person)
    const geometry = new THREE.CapsuleGeometry(0.5, 1.0, 4, 8);
    const material = new THREE.MeshBasicMaterial({ 
      color: 0x0000ff,
      wireframe: true,
      visible: false // Invisible in first-person
    });
    this.mesh = new THREE.Mesh(geometry, material);
    this.mesh.position.y = 0.75; // Center of capsule
    
    // Add mesh to object
    this.object.add(this.mesh);
    
    console.log("PlayerModel created");
  }
  
  /**
   * Gets the player object
   * @returns The player object
   */
  public getObject(): THREE.Object3D {
    return this.object;
  }
  
  /**
   * Gets the player mesh
   * @returns The player mesh
   */
  public getMesh(): THREE.Mesh {
    return this.mesh;
  }
  
  /**
   * Sets the player position
   * @param position The position to set
   */
  public setPosition(position: THREE.Vector3): void {
    this.object.position.copy(position);
  }
  
  /**
   * Gets the player position
   * @returns The player position
   */
  public getPosition(): THREE.Vector3 {
    return this.object.position.clone();
  }
  
  /**
   * Gets the player's eye position (for camera placement)
   * @returns The eye position
   */
  public getEyePosition(): THREE.Vector3 {
    return new THREE.Vector3(
      this.object.position.x,
      this.object.position.y + this.eyeHeight,
      this.object.position.z
    );
  }
  
  /**
   * Cleans up resources when the player model is no longer needed
   */
  public dispose(): void {
    // Dispose of geometry
    if (this.mesh.geometry) {
      this.mesh.geometry.dispose();
    }
    
    // Dispose of material
    if (this.mesh.material instanceof THREE.Material) {
      this.mesh.material.dispose();
    } else if (Array.isArray(this.mesh.material)) {
      this.mesh.material.forEach(material => material.dispose());
    }
  }
} 